import React from "react";

const ShippingPopup = ({
  isShippingPopUpOpen,
  shippingDetails,
  setIsShippingPopUpOpen,
}) => {
  // console.log(shippingDetails);
  const { name, mobile, country, city, road, house, postalCode } = shippingDetails && shippingDetails.shippingDetails;
  const { createdAt, updatedAt, isDelivered } =
    shippingDetails && shippingDetails;
  const localOrderTime = new Date(createdAt).toLocaleTimeString();
  const localOrderDate = new Date(createdAt).toLocaleDateString();
  const localReceivedTime = new Date(updatedAt).toLocaleTimeString();
  const localReceivedDate = new Date(updatedAt).toLocaleDateString();
  return (
    <div
      className={`${
        isShippingPopUpOpen
          ? "popupShipping show-popUp-shipping"
          : "popupShipping"
      }`}
    >
      <div className="shippingpopupboxdetails">
        <h2>Shipping Status</h2>
        <p>
          {isDelivered ? (
            <span style={{ color: "green" }}>Received</span>
          ) : (
            <span style={{ color: "red" }}>Not Received</span>
          )}
        </p>
        <p>
          Order Time: {localOrderDate},{localOrderTime}
        </p>
        <p>
          Received Time:
          {isDelivered ? (
            <span>
              {localReceivedDate},{localReceivedTime}
            </span>
          ) : (
            <span>____________________</span>
          )}
        </p>
        <p style={{ textDecoration: "underline", color: "blue" }}>
          Address of Shipping:
        </p>
        <h3>{name}</h3>
        <h4>{mobile}</h4>
        <h5>Country: {country}</h5>
        <h5>City: {city}</h5>
        <h4>{road}</h4>
        <h5>Postal Code: {postalCode}</h5>
        <h5>House Holding No. {house || "not given"}</h5>
        <button onClick={() => setIsShippingPopUpOpen(false)}>Close</button>
      </div>
    </div>
  );
};

export default ShippingPopup;
